function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Notification icon"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Subtraction 43",
  d: "M7.002 13.999a7.008 7.008 0 01-7-7 7.008 7.008 0 017-7 7.036 7.036 0 014.947 2.05 6.947 6.947 0 012.053 4.95 7.008 7.008 0 01-7 7zM6.97 9.366a.821.821 0 00-.575.238.82.82 0 00-.237.61.817.817 0 00.237.6.828.828 0 00.584.238h.062a.813.813 0 00.569-.235.808.808 0 00.235-.6.825.825 0 00-.235-.612.81.81 0 00-.57-.236h-.069zM7 2.994a.525.525 0 00-.579.439l.1 4.229a.349.349 0 00.229.336.6.6 0 00.249.053.6.6 0 00.25-.053.344.344 0 00.228-.336l.1-4.23a.523.523 0 00-.575-.439z",
  fill: "#f3d124"
}));

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.002 13.999"
  }, props), _ref);
}

export default SvgWarning;